//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'Teeth',
  data() {
    return {
      activeType: 'hinchey',
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
    exclusiveChild(type) {
      this.activeType = type
    },
  },
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Trauma/Chart_Teeth.vue